import type { EventIncidentType } from "app/types/eventType";
import { FormattedMessage } from "react-intl";
import "./EventPhase.scss";

type Props = {
  eventIncident: EventIncidentType;
};

const EventPhase: React.FC<Props> = ({ eventIncident }) => {
  const renderPhase = () => {
    switch (eventIncident["eventPhase"]) {
      case "FIRST_HALF":
        return <FormattedMessage tagName="span" id="events-phase-1H" />;

      case "EXTRA_TIME_FIRST_HALF":
        return <FormattedMessage tagName="span" id="events-phase-1H" />;

      case "SECOND_HALF":
        return <FormattedMessage tagName="span" id="events-phase-2H" />;

      case "EXTRA_TIME_SECOND_HALF":
        return <FormattedMessage tagName="span" id="events-phase-2H" />;

      case "HALF_TIME":
        return <FormattedMessage tagName="span" id="events-phase-HT" />;

      case "EXTRA_TIME_HALF_TIME":
        return <FormattedMessage tagName="span" id="events-phase-HT" />;

      case "PRE_MATCH":
        return "";

      case "BEFORE_EXTRA_TIME":
        return <FormattedMessage tagName="span" id="events-phase-BET" />;

      default:
        return <FormattedMessage tagName="span" id="events-phase-PM" />;
    }
  };

  return <div className="eventPhase">{renderPhase()}</div>;
};

export default EventPhase;
